import types from './types';

const INITIAL_STATE = {
  isUpdating: false,

  result: [],
};

const appUserProfileReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {

    case types.UPDATE_PROFILE_REQUEST:
      return {
        ...state,
        result: [],
        isUpdating: true,
      };

    case types.UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isUpdating: false,
      };

    case types.UPDATE_PROFILE_FAILURE:
      return {
        ...state,
        result: [],
        isUpdating: false,
      };

    default:
      return state;
  }
};

export default appUserProfileReducer;
